import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ColorField } from '../../../commons/ui/fields/ColorField';
import { AddMarkingToolBl } from '../../AddMarkingTool.bl';
import { IAddMarkingToolStore } from '../../AddMarkingTool.store';

export const ColorFieldContainer = observer((): ReactElement => {
  const bl = useInjection(AddMarkingToolBl.$);
  const store = useInjection(IAddMarkingToolStore.$);

  const handleChange = (color: string): void => {
    bl.changeColor(color);
  };

  return (
    <ColorField
      isRequired
      color={store.color}
      onChangeColor={handleChange}
    />
  );
});
